var disableRightClick = {
    init: function() {
        var self = this;

        $( 'img' ).on( 'contextmenu', function( e ){
        	e.preventDefault();
	        return false;
	    } );
    }
};

export { disableRightClick };